import React from "react";
var __jsx = React.createElement;
import { SELECTED_ENV, SHOW_DEBUG_INFO } from "@globalConfig";
import stl from "./Header.module.css";
import { dispatchSideMenuToggle as toggleMenu } from "@/_LayoutsRelated/layoutHooks/useSideMenuController";
import useDesktopNavVariant from "./DesktopHeader/useDesktopNavVariant";
import DesktopHeader from "./DesktopHeader/DesktopHeader";
import MobileHeader from "./MobileHeader/MobileHeader";
import useMobileHeaderVariant from "./MobileHeader/useMobileHeaderVariant";
var getEnvironmentColor = function getEnvironmentColor() {
  var env = SELECTED_ENV.toLowerCase();
  switch (env) {
    case 'prod':
    case 'production':
      return 'inherit';
    case 'qa':
      return '#DC2626';
    // red-600
    case 'preprod':
      return '#D97706';
    // amber-600
    case 'dev':
      return '#EA580C';
    // orange-600
    default:
      return '#16A34A';
    // green-600
  }
};
var Header = function Header(props) {
  var desktopNavVariant = useDesktopNavVariant(props.desktopNavVariant);
  var mobileHeaderVariant = useMobileHeaderVariant(props.mobileHeaderVariant);
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.custommobileHeaderFragmentOnly ? props.custommobileHeader : props.custommobileHeader && /*#__PURE__*/React.createElement("div", {
    className: props.custommobileHeader ? ["m-show", stl.custommobileHeader].join(" ") : undefined
  }, props.custommobileHeader), /*#__PURE__*/React.createElement("header", {
    className: [stl.siteHeader, props.className ? props.className : "", props.hideHeaderOnmobile ? "m-hide" : undefined, stl.hasNewNav].join(" ")
  }, SHOW_DEBUG_INFO && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: getEnvironmentColor(),
      color: 'white',
      padding: '16px 20px',
      fontSize: '12px',
      fontWeight: 'bold',
      borderRadius: '0 0 4px 4px',
      zIndex: 1000
    }
  }, SELECTED_ENV.toUpperCase()), /*#__PURE__*/React.createElement("div", {
    id: "desktopNav",
    className: "m-hide"
  }, /*#__PURE__*/React.createElement(DesktopHeader, {
    variant: desktopNavVariant,
    showSearchBar: props.showSearchBar,
    setUnbxdPage: props.setUnbxdPage,
    switchLink: props.switchLink,
    logoNotClickable: props.logoNotClickable,
    showCartIcon: props.showCartIcon
  })), !props.custommobileHeader && /*#__PURE__*/React.createElement("div", {
    id: "desktopHeader"
  }, /*#__PURE__*/React.createElement(MobileHeader, {
    variant: mobileHeaderVariant,
    mobileHasBack: props.mobileHasBack,
    mobileHasTitle: props.mobileHasTitle,
    mobileNoLogo: props.mobileNoLogo,
    logoNotClickable: props.logoNotClickable,
    burgrMenuisCncl: props.burgrMenuisCncl,
    hideBurgerMenu: props.hideBurgerMenu,
    hideSideMenue: props.hideSideMenue,
    tracking: props.tracking,
    showCartIcon: props.showCartIcon,
    showUserAvatar: props.showUserAvatar,
    headerActions: props.mobileHeaderActions
  })), /*#__PURE__*/React.createElement("span", {
    onClick: toggleMenu,
    className: "sideMenuToggle hide cursor-pointer",
    id: "side-menu-toggle",
    "aria-hidden": "true"
  })));
};
export default Header;